import axios from 'axios';
import _ from 'lodash';

export const getRegularMaintenance = () => {
  return axios.get(`/cms/maintenance/regular_maintenance/list`).then((res) => {
    if (res.data.code === 0) {
      // console.log(res.data.data);
      return _.get(res, 'data.data', []);
    }
  });
};

export const recalculateReport = (payload) => {
  return axios.post(`/system/report_transaction/repair`, payload).then((res) => {
    if (res.data.code === 0) {
      return _.get(res, 'data.data', []);
    }
  });
};

export const getReportRepairStatus = ({ page, limit }) => {
  const params = {
    status: ['pending', 'success', 'failed'],
    topic: 'report-snapshot-calculate',
    page,
    limit,
  };
  return axios.get('/system/report_transaction/repair/status', { params }).then((res) => {
    if (res.data.code === 0) {
      return _.get(res, 'data.data', []);
    }
  });
};
